<template>
    <o-form-group
        :form-state="formState"
        :label="label"
        :message="errorMessages"
        :nolabel="nolabel"
        :type="{ 'is-danger': hasError }"
    >
        <o-file-upload
            :class="input_class"
            :file="value"
            :form-state="formState"
            @change="on_change"
            v-bind="$attrs"
            v-on="inputListeners"
        >
        </o-file-upload>
        <o-file-preview
            :disable-download="disableDownload"
            :file="value"
            v-if="showPreview"
        />
    </o-form-group>
</template>

<script>
import FormComponentMixin from "../../../mixins/form_component_mixin";
import OFormGroup from "../OFormGroup";
import OFilePreview from "../../../filesystem/OFilePreview";
import OFileUpload from "../../../filesystem/OFileUpload";

export default {
    name: "OFileInput",
    components: { OFormGroup, OFilePreview, OFileUpload },
    mixins: [FormComponentMixin],
    props: {
        showPreview: { type: Boolean, default: false },
        "disable-download": { type: Boolean, default: true },
    },
};
</script>

<style scoped></style>
